export default "__VITE_PUBLIC_ASSET__afbd2b1c__"